import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { resource }: Boundaries["validatePersonalTimeRecordsUpToDate"]["request"],
): State {
  const index = state.findIndex((req) => req.resource.uuid === resource.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { resource, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { resource, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { resource }: Boundaries["validatePersonalTimeRecordsUpToDate"]["success"],
): State {
  const index = state.findIndex((req) => req.resource.uuid === resource.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { resource, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { resource, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { resource }: Boundaries["validatePersonalTimeRecordsUpToDate"]["failure"],
): State {
  const index = state.findIndex((req) => req.resource.uuid === resource.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { resource, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { resource, request: setRequestStateToFailure() }];
}

const reduceState = createStateReducer(initialState, {
  [events.validatePersonalTimeRecordsUpToDateRequested]: handleRequest,
  [events.validatePersonalTimeRecordsUpToDateSucceeded]: handleSuccess,
  [events.validatePersonalTimeRecordsUpToDateFailed]: handleFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
